import { getEnv } from '../utils/environment';
let s3Env = getEnv();
let host;
let protocol;

switch (getEnv()) {
	case 'dev':
		host = 'dev.santillana.com.br';
		protocol = 'https:';
		break;
	case 'hml':
		host = 'homol.santillana.com.br';
		protocol = 'https:';
		break;
	case 'prd':
		host = 'santillana.com.br';
		protocol = 'https:';
		break;
	default:
		s3Env = 'dev';
		host = 'dev.santillana.com.br';
		protocol = 'https:';
		break;
}

let axiosConfig = {
		development: {
			baseURL: '/cms/index.php/wp-json',
			contentUrl: `${protocol}//${host}/cms/wp-content`,
			uploadsUrl: `https://sta-s3-${s3Env}.s3.amazonaws.com/cms/wp-content/uploads`,
			withCredentials: true
		},
		production: {
			baseURL: '/cms/index.php/wp-json',
			contentUrl: `${protocol}//${host}/cms/wp-content`,
			uploadsUrl: `https://sta-s3-${s3Env}.s3.amazonaws.com/cms/wp-content/uploads`,
			withCredentials: true
		}
	}

// Garante URLs válidas mesmo se env falhar (evita undefined//undefined)
if (!host || host === 'undefined' || !protocol || protocol === 'undefined') {
	host = 'dev.santillana.com.br';
	protocol = 'https:';
	s3Env = 'dev';
	axiosConfig.development.contentUrl = `${protocol}//${host}/cms/wp-content`;
	axiosConfig.development.uploadsUrl = `https://sta-s3-${s3Env}.s3.amazonaws.com/cms/wp-content/uploads`;
	axiosConfig.production.contentUrl = `${protocol}//${host}/cms/wp-content`;
	axiosConfig.production.uploadsUrl = `https://sta-s3-${s3Env}.s3.amazonaws.com/cms/wp-content/uploads`;
}

export default axiosConfig[process.env.NODE_ENV];